import { render, staticRenderFns } from "./customerdashboard.vue?vue&type=template&id=677f87a8"
import script from "./customerdashboard.vue?vue&type=script&lang=js"
export * from "./customerdashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports